import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import { useBrandingData } from '../components/DataProviders';
import { BtLink } from '../components/BtLink';
import LineItems, { LineItemCount } from '../components/LineItems';
import Icon from '../components/Icon';


const useStyles = makeStyles( theme => ({
  root: {
    marginTop: '40px',
    width: '100%'
  },
  heading: ({ titleColor }) => ({
    fontSize: '24px',
    lineHeight: '26px',
    fontWeight: '600',
    color: titleColor
  }),
  lineItems: {
    marginTop: '10px',
    width: '100%',
    borderCollapse: 'collapse',
    borderSpacing: '0',
    '& td, & th': {
      padding: '6px',
      border: '1px solid #d9d9da',
      borderCollapse: 'collapse',
      borderSpacing: '0'
    },
    '& td': {
      height: '133px',
      [theme.breakpoints.down('xs')]: {
        height: '93px'
      }
    },
    '& th': {
      background: '#f9f9f9',
      color: '#46484b',
      fontWeight: '600',
      fontSize: '14px'
    },
    '& tfoot th:not(:first-child)': {
      borderLeft: 'none'
    },
    '& tfoot th:not(:last-child)': {
      borderRight: 'none'
    }
  },
  mainInfoHeader: {
    textAlign: 'left'
  },
  currencyHeader: {
    textAlign: 'right'
  },
  itemImage: {
    width: '120px',
    height: '120px',
    display: 'flex',
    alignItems: 'center',
    '&:empty': {
      display: 'none'
    },
    [theme.breakpoints.down('xs')]: {
      width: '70px',
      height: '70px'
    }
  },
  itemMainInfo: {
    display: 'flex',
  },
  itemNameAndDetails: {
    display: 'block',
    marginLeft: '15px',
    [theme.breakpoints.down('xs')]: {
      marginLeft: '8px'
    }
  },
  itemName: {
    fontSize: '18px',
    lineHeight: '22px',
    fontWeight: '600',
    [theme.breakpoints.down('xs')]: {
      fontSize: '16px'
    }
  },
  itemQuantity: {
    textAlign: 'center',
    verticalAlign: 'top',
    fontSize: '14px',
    fontWeight: '400'
  },
  currencyCell: {
    textAlign: 'right',
    color: '#5cb85c',
    verticalAlign: 'top',
    fontSize: '14px',
    fontWeight: '400'
  },
  togglerFooter: {
    textAlign: 'left'
  }
}));


const useOptionStyles = makeStyles( theme => ({
  options: {
    fontSize: '14px',
    fontWeight: '400',
    color: '#777',
    listStyleType: 'none',
    paddingLeft: '0',
    margin: '0',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px'
    }
  },
  optionLabel: {
    fontWeight: 'bold',
    textTransform: 'capitalize',
    marginRight: '4px'
  }
}));

export default function OrderTable() {
  const { toggles: { show_shipment_details, show_shipment_prices }, colors } = useBrandingData();
  const classes = useStyles({ titleColor: colors.primary });
  const optionClasses = useOptionStyles();

  const [shown,setShown] = useState(false);

  if( !show_shipment_details ) {
    return null;
  }

  return (
    <div className={classes.root}>
      <div className={classes.heading}>
        This shipment contains <LineItemCount />...
      </div>
      <table className={classes.lineItems}>
        { shown && <>
          <thead>
            <tr>
              <th className={classes.mainInfoHeader}>Product</th>
              <th>Qty</th>
              { show_shipment_prices && <>
                <th className={classes.currencyHeader}>Price</th>
                <th className={classes.currencyHeader}>Total</th>
              </>}
            </tr>
          </thead>
          <tbody>
            <LineItems className={classes.lineItems}>
              { ({ Image, name, Options, quantity, unitPrice, subtotal }) => (
                <tr>
                  <td>
                    <div className={classes.itemMainInfo}>
                      <div className={classes.itemImage}>
                        <Image />
                      </div>
                      <div className={classes.itemNameAndDetails}>
                        <div className={classes.itemName}>{name}</div>
                        <Options classes={optionClasses} />
                      </div>
                    </div>
                  </td>
                  <td className={classes.itemQuantity}>
                    {quantity}
                  </td>
                  { show_shipment_prices && <>
                    <td className={classes.currencyCell}>
                      {unitPrice}
                    </td>
                    <td className={classes.currencyCell}>
                      {subtotal}
                    </td>
                  </>}
                </tr>
              )}
            </LineItems>
          </tbody>
        </>}
        <tfoot>
          <tr>
            <th colSpan="4" className={classes.togglerFooter}>
              { shown ? <>
                <Icon icon={faChevronUp} />&nbsp;
                <BtLink onClick={() => setShown(false)}>Hide order details...</BtLink>
              </>:<>
                <Icon icon={faChevronDown} />&nbsp;
                <BtLink onClick={() => setShown(true)}>View the Details of your order...</BtLink>
              </>}
            </th>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}